export default __webpack_public_path__ + "static/media/new_court.5a204393.svg";